<template>
  <v-container class="container-dashboard" fluid v-if="token && viewRoute">
    <tableau-viz id="tableauViz"       
      :src="`${server}/#/site/${site}/views/${viewRoute}`"
      :token="token"
      class="container-dashboard"
    >
    </tableau-viz>
  </v-container>
</template>

<script>
import { logIntoTableau, generateTableauJwt } from '../utils/serverRequests'
import { publicTableauInfo } from '../utils/tableau/publicTableauInfo'
export default {
  name: "Dashboard",
  data() {
    return {
      server: publicTableauInfo.server,
      site: publicTableauInfo.site,
      viewRoute: false,
      siteName: null,
      token: false
    }
  },
  mounted() {
    if(!this.$route.params.dashboard || !!!this.$store.state.views.length) {
      this.getViewsFromTableau()
    } else {
      this.getJwtFromTableau()
      this.viewRoute = this.$route.params.dashboard.split("-").join("/")
    }
  },
  methods: {
    getViewsFromTableau: async function() {
      await logIntoTableau(this.$store.state.jwt)
        .then(response => {
          this.siteName = response.data.siteName
          this.viewRoute = response.data.allowedDashboards[0].embedUrl
          const views = response.data.allowedDashboards.map(dashboard => {
            return {
              ...dashboard,
              view: dashboard.embedUrl.split("/").join("-")
            }
          })
          this.$store.commit('definedViews', views)
          if(response.data.jwtTableau) {
            this.token = response.data.jwtTableau
          }
          this.$router.push({ name: 'dashboard', params: { dashboard: views[0].view } })
        })
    },
    getJwtFromTableau: async function() {
      await generateTableauJwt(this.$store.state.jwt).then(response => {
        this.token = response.data.jwtTableau
      })
    }
  }
};
</script>

<style scoped>
  .container-dashboard{
    height: 100%;
  }
</style>
